<template>
  <div class="telzxhpls">
    <div class="rmlabt">
      合肥电话咨询好评律师<span>三大认证保护，信赖之选！</span>
    </div>
    <div class="telzxhplslist">
      <div class="telzxhplsitem between" v-for="item in 5" :key="item">
        <div class="rufm">
          <img src="../../../assets/telzx/bbbb2.png" alt="" />
        </div>
        <div class="cenxgxx">
          <div class="lsxm">张三<span>律师</span></div>
          <div class="scly">擅长领域：劳动纠纷、婚姻家庭、公司上市</div>
          <div class="wzjs">
            作为法律人，我的信仰就是良法与善治。追求良法，但又清楚法律
            的滞后性和内容局限...
            <span class="ckgd">查看更多 >></span>
          </div>
          <div class="price"><span>¥49</span>/20分钟</div>
        </div>
        <div class="lxbz">
          <div class="dhzx center">
            <svg-icon icon-class="dianhua" /> 电话咨询
          </div>
          <div class="lzwz">已帮助：<span>12345</span>人</div>
          <div class="lzwz">获好评数：<span>1000</span>次</div>
        </div>
      </div>
    </div>
    <div class="pagination mt50">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        :current-page="currentPage"
        :pager-count="5"
        @current-change="turnpage"
        @prev-click="turnpage(--currentPage)"
        @next-click="turnpage(++currentPage)"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  methods: {
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.telzxhpls {
  width: 100%;
  .rmlabt {
    font-size: 22px;
    color: #333333;
    font-weight: bold;
    span {
      font-size: 14px;
      color: #999999;
      margin-left: 20px;
      font-weight: 400;
    }
  }
  .telzxhplslist {
    margin-top: 30px;
    .telzxhplsitem {
      width: 100%;
      padding: 20px;
      border-bottom: 1px dashed #999;
      .rufm {
        width: 160px;
        img {
          width: 160px;
          height: 160px;
        }
      }
      .cenxgxx {
        width: 410px;
        position: relative;
        .lsxm {
          font-size: 26px;
          color: #0465ea;
          line-height: 26px;
          span {
            margin-left: 10px;
            font-size: 16px;
            color: #aaaaaa;
          }
        }
        .scly {
          margin-top: 15px;
          font-size: 14px;
          color: #333333;
          line-height: 14px;
        }
        .wzjs {
          margin-top: 15px;
          font-size: 14px;
          color: #666666;
          line-height: 22px;
          position: relative;
          .ckgd {
            position: absolute;
            bottom: 0;
            right: 0;
            font-size: 12px;
            color: #aaaaaa;
            cursor: pointer;
          }
        }
        .price {
          margin-top: 15px;
          font-size: 14px;
          color: #aaaaaa;
          span {
            color: #ff4646;
          }
        }
        &::after {
          content: "";
          width: 1px;
          height: 100px;
          background: #aaaaaa;
          position: absolute;
          top: 30px;
          right: -20px;
        }
      }
      .lxbz {
        width: 190px;
        text-align: center;
        .dhzx {
          width: 120px;
          height: 30px;
          line-height: 30px;
          background: #ec3a3a;
          border-radius: 15px;
          font-size: 16px;
          color: #ffffff;
          margin: 0 auto;
          cursor: pointer;
        }
        .lzwz {
          margin-top: 15px;
          font-size: 14px;
          color: #333333;
          span {
            color: #ec3a3a;
          }
        }
      }
      &:hover {
        box-shadow: 0px 2px 18px 0px rgba(1, 1, 1, 0.18);
        border-bottom: none;
        .cenxgxx {
          .wzjs .ckgd {
            color: #0465ea;
          }
        }
      }
    }
  }
  .pagination {
    text-align: center;
    ::v-deep .el-pagination.is-background .btn-next,
    ::v-deep .el-pagination.is-background .btn-prev,
    ::v-deep .el-pagination button,
    ::v-deep .el-pagination span:not([class*="suffix"]),
    ::v-deep .el-pagination.is-background .el-pager li {
      min-width: 36px;
      height: 36px;
      line-height: 36px;
    }
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active,
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover {
      color: #ffffff !important;
      background: #0057ff !important;
    }
  }
}
</style>